import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { translate, TranslocoService } from '@ngneat/transloco';
import { CommandsSchema } from '@iotsens/commands';
import { CommandExec } from '@iotsens/commands/src/lib/_shared/domain/command-exec.model';

@Component({
  selector: 'app-zmx-commands',
  templateUrl: './zmx-commands.component.html',
  styleUrls: ['./zmx-commands.component.scss']
})
export class ZmxCommandsComponent implements OnInit {

  @Input() schema: CommandsSchema;

  @Output() executeCommand: EventEmitter<CommandExec>;

  public configuration: any;

  constructor(private i18n: TranslocoService) {
    this.executeCommand = new EventEmitter<CommandExec>();
  }

  ngOnInit(): void {
    this.setConfiguration();
  }

  private setConfiguration(): void {
    const languageLabels = {}; // TODO: replace when the machine model is available in platform
    for (let i = 0; i < 24; i++) {
      languageLabels[i+''] = i+'';
    }
    this.i18n.selectTranslation().subscribe(() => {
      this.configuration = {
        classes: 'm-auto md:col-6',
        commands: {
          setSweeperEnabled: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                enabled: {
                  name: translate('command.setSweeperEnabled'),
                  labels: {
                    '0': translate('command.value.disabled'),
                    '1': translate('command.value.enabled')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          setSweeperMode: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                mode: {
                  name: translate('command.setSweeperMode'),
                  labels: {
                    '0': translate('command.value.continuous'),
                    '1': translate('command.value.discontinuous')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          setSweeperSpeed: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                speed: {
                  name: translate('command.setSweeperSpeed'),
                  labels: {
                    '0': translate('command.value.stop'),
                    '1': translate('command.value.slow'),
                    '2': translate('command.value.normal'),
                    '3': translate('command.value.fast')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          setWasteEnabled: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                enabled: {
                  name: translate('command.setWasteEnabled'),
                  labels: {
                    '0': translate('command.value.disabled'),
                    '1': translate('command.value.enabled')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          setWasteLimit: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                limit: {
                  name: translate('command.setWasteLimit')
                }
              },
              button: translate('common.save')
            }
          },
          setLanguage: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                code: {
                  name: translate('command.setLanguage'),
                  labels: languageLabels
                }
              },
              button: translate('common.save')
            }
          },
          setFruitsPro: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                amount: {
                  name: translate('command.setFruitsPro')
                }
              },
              button: translate('common.save')
            }
          },
          setLockPro: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                enabled: {
                  name: translate('command.setLockPro'),
                  labels: {
                    '0': translate('command.value.disabled'),
                    '1': translate('command.value.enabled')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          setSelUpDownDisc: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                state: {
                  name: translate('command.setSelUpDownDisc'),
                  labels: {
                    '0': translate('command.value.off'),
                    '1': translate('command.value.up'),
                    '2': translate('command.value.down')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          setUpValue: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                amount: {
                  name: translate('command.setUpValue')
                }
              },
              button: translate('common.save')
            }
          },
          setDownValueDisc: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                amount: {
                  name: translate('command.setDiscValue')
                  // TODO: replace when the machine model is available in platform
                  // name: (this.machine.model.modelName === 'Versatile Pro') ? this.i18n.translate('command.setDiscValue') : this.i18n.translate('command.setDownValue')
                }
              },
              button: translate('common.save')
            }
          },
          setCashlessModeFruitNumber: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                amount: {
                  name: translate('command.setCashlessModeFruitNumber')
                }
              },
              button: translate('common.save')
            }
          },
          setPinCt: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                pin: {
                  name: translate('command.setPinCt')
                }
              },
              button: translate('common.save')
            }
          },
          setPinMaster: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                pin: {
                  name: translate('command.setPinMaster')
                }
              },
              button: translate('common.save')
            }
          },
          setPinUser: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                pin: {
                  name: translate('command.setPinUser')
                }
              },
              button: translate('common.save')
            }
          },
          setPinSat: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                pin: {
                  name: translate('command.setPinSat')
                }
              },
              button: translate('common.save')
            }
          },
          setIotTimeout: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                minutes: {
                  name: translate('command.setIotTimeout')
                }
              },
              button: translate('common.save')
            }
          },
          setIotSelControl: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              command: '',
              params: {
                mode: {
                  name: translate('command.setIotSelControl'),
                  labels: {
                    '0': translate('command.value.off'),
                    '1': translate('command.value.ppuOn'),
                    '2': translate('command.value.iotOn')
                  }
                }
              },
              button: translate('common.save')
            }
          },
          reboot: {
            inline: true,
            buttonClasses: 'w-auto',
            literals: {
              button: translate('command.reboot')
            }
          },
          restoreFifo: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              button: translate('command.restoreFifo')
            }
          },
          getMemmap: {
            inline: true,
            buttonClasses: 'w-10rem',
            literals: {
              button: translate('command.getMemmap'),
            }
          },
          machineResetPartialFruitCounter: {
            inline: true,
            buttonClasses: 'w-auto',
            literals: {
              button: translate('command.machineResetPartialFruitCounter')
            }
          },
          machineCpuReset: {
            inline: true,
            buttonClasses: 'w-auto',
            literals: {
              button: translate('command.machineCpuReset')
            }
          },
          machineEnable: {
            inline: true,
            buttonClasses: 'w-auto',
            literals: {
              button: translate('command.machineEnable')
            }
          },
          machineDisable: {
            inline: true,
            buttonClasses: 'w-auto',
            literals: {
              button: translate('command.machineDisable')
            }
          },
          machineFruitsCashlessReset: {
            inline: true,
            buttonClasses: 'w-auto',
            literals: {
              button: translate('command.machineFruitsCashlessReset')
            }
          }
        }
      }
    });
  }

}
